import { useContext } from "react";
import { BreadcrumbTrailContext } from "../context/BreadcrumbTrailContext.ts";

export const useBreadcrumbTrail = () => {
  const ctx = useContext(BreadcrumbTrailContext);
  if (!ctx) throw new Error("useBreadcrumbTrail must be used within BreadcrumbTrailProvider");
  return ctx;
};
